(function(){
  var root=document.getElementById('ma-collection');
  if(!root)return;
  var products=[].slice.call(root.querySelectorAll('.ma-product'));
  var filters=[].slice.call(root.querySelectorAll('[data-filter]'));
  var count=root.querySelector('.ma-filtercount');
  var toast=root.querySelector('.ma-toast');
  var cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  if(count)count.textContent=products.length+' miel'+(products.length>1?'s':'');

  filters.forEach(function(button){
    button.addEventListener('click',function(){
      var n=0;
      filters.forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});
      products.forEach(function(p){
        var show=button.dataset.filter==='all'||p.dataset.profile===button.dataset.filter;
        p.hidden=!show;if(show)n++;
      });
      if(count)count.textContent=n+' miel'+(n>1?'s':'');
    });
  });

  products.forEach(function(p){
    var form=p.querySelector('.ma-form');
    if(!form)return;
    var add=form.querySelector('.ma-add');
    var idInput=form.querySelector('input[name="id"]');
    function setAvailable(ok){
      add.disabled=!ok;
      add.innerHTML=ok?'<span>Ajouter au panier</span><span aria-hidden="true">+</span>':'<span>Momentanément indisponible</span>';
    }
    [].forEach.call(form.querySelectorAll('.ma-sizegroup button'),function(button,i,all){
      button.addEventListener('click',function(){
        [].forEach.call(all,function(b){b.setAttribute('aria-pressed',String(b===button));});
        idInput.value=button.dataset.variant;
        p.querySelector('.ma-price').textContent=button.dataset.price;
        p.querySelector('.ma-unit').textContent=button.dataset.kilo;
        setAvailable(button.dataset.available==='true');
      });
    });
    form.addEventListener('submit',function(e){
      if(!window.fetch)return;
      e.preventDefault();
      if(add.disabled)return;
      add.disabled=true;
      fetch(cartRoot+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(d){if(!r.ok)throw new Error(d.description||d.message||'Ajout impossible pour le moment.');return d;});})
        .then(function(item){return fetch(cartRoot+'cart.js').then(function(r){return r.json();}).then(function(cart){
          [].forEach.call(document.querySelectorAll('[data-cart-count]'),function(el){el.textContent=cart.item_count;});
          if(toast){toast.hidden=false;toast.innerHTML='';var t=document.createElement('span');t.textContent=p.dataset.name+' · '+(item.variant_title||'')+' ajouté au panier ('+cart.item_count+' article'+(cart.item_count>1?'s':'')+'). ';var a=document.createElement('a');a.href=cartRoot+'cart';a.textContent='Voir le panier →';a.style.fontWeight='800';a.style.textDecoration='underline';toast.append(t,a);}
        });})
        .catch(function(err){if(toast){toast.hidden=false;toast.textContent=err.message;}})
        .then(function(){add.disabled=false;});
    });
  });
})();
